import BaseApplication from './base.js';

import swal from 'sweetalert';
import IMask from 'imask';

'use strict';

export default class BaseContact extends BaseApplication {
	constructor(args = []) {
		super(args);
		this.setLog('[Extension] ', "Contact Application");
		
		this.contactForm = {
			step: "default"
		};
	}
	
	setForms() {
		const self = this;
		this.form = document.getElementById(this.contact.id);
		this.form.setAttribute("data-form-step", this.contactForm.step);
		
		if(!this.isEmpty(this.form) && !this.isEmpty(this.form.getAttribute("id"))) {
			this.bindForm(this.form, this.contact.route+this.form.getAttribute("id"));
		}
	}
	
	bindForm(targetForm, targetRoute) {
		const self = this;
		
		this.form.addEventListener("submit", function(event) {
			event.preventDefault();
			sendForm(this);
		});
		
		var formReturn = document.getElementsByClassName("form-return")[0];
		if (!self.isEmpty(formReturn)) {
			formReturn.addEventListener("click", function(event) {
				event.preventDefault();
				setLoader(true);
				setFormStep("default");
			});
		}
		
		const inputMaskList = this.form.querySelectorAll("[data-mask]");
		if(!this.isEmpty(inputMaskList)) {
			[].forEach.call(inputMaskList, function(inputMask) {
				var maskPattern = inputMask.getAttribute("data-mask");
				if(!self.isEmpty(maskPattern)) {
					IMask(inputMask, {
						mask: maskPattern
					});
				}
			});
		}
		
		const conditionalInputs = this.form.querySelectorAll("[data-if]");
		if(!this.isEmpty(conditionalInputs)) {
			[].forEach.call(conditionalInputs, function(conditionalInput) {
				var ifConditions = JSON.parse(conditionalInput.getAttribute("data-if"));
				var elseConditions = JSON.parse(conditionalInput.getAttribute("data-else"));
				for (var key in ifConditions) {
					var target = document.getElementById(key);
					var conditionAction = function(conditionMatch, target) {}
					if (!self.isEmpty(elseConditions)) {
						conditionAction = function(conditionMatch, target) {
							var actionTarget = target.parentNode.parentNode;
							if (!self.isEmpty(elseConditions["hide"])) {} {
								if (elseConditions["hide"]==conditionMatch) {
									actionTarget.classList.remove("null");
								} else {
									actionTarget.classList.add("null");
									target.value = null;
								}
							}
						}
					}
					var conditionTrigger = function() {
						conditionAction((self.form.elements[key].value == ifConditions[key]), conditionalInput);
					}; 
					
					target.addEventListener("change", conditionTrigger);
					conditionTrigger();
				}
			});
		}
		
		function setLoader(status) {
			if(status) {
				self.isSending = true;
				targetForm.classList.add("isLoading");
				targetForm.classList.remove("isDone");
			} else {
				self.isSending = false;
				targetForm.classList.remove("isLoading");
				targetForm.classList.add("isDone");
			}
		}
		
		function setFormStep(step) {
			setTimeout(function() {
				if (step == "check") {
					for (var i = 0; i < self.form.elements.length; i++) {
						var element = self.form.elements[i];
						if (element.type == "textarea") {
							element.nextElementSibling.innerText = element.value;
						}
					}
				}
				
				self.form.setAttribute("data-form-step", step);
				self.contactForm.step = step;
				setLoader(false);
			}, 1000);
		}
		
		function sendForm(formEvent) {
			if(self.isSending) { return; }
			setLoader(true);
			
			var errorFields = formEvent.getElementsByClassName("field-errors");
			while (errorFields[0]) {
				errorFields[0].previousElementSibling.classList.remove("has-error");
				errorFields[0].parentNode.removeChild(errorFields[0]);
			}
			
			if (self.contactForm.step == "default") {
				setFormStep("check");
				return;
			}
			
			self.ajax({
				method: 'POST',
				route: targetRoute,
				responseType: "json",
				data: new FormData(formEvent),
				complete: function(xhr, data) {
					setLoader(false);
				},
				success: function(xhr, data) {
					var response = data.response;
					if(typeof response != 'object') { response = JSON.parse(response); }
					if(!self.isEmpty(response)) {
						if(response !== true && typeof response == 'object') {
							var responseTarget = document.getElementById(response.form);
							if(!self.isEmpty(responseTarget)) {
								if (!self.isEmpty(response.error)) {
									throwFormError(response);
								}
								
								setLoader(true);
								
								for (var key in response.fields) {
									if(response.fields.hasOwnProperty(key)) {
										var field = {
											'name': key,
											'element': document.getElementById(key),
											'data': response.fields[key]
										}
										if (!self.isEmpty(field.element) && key != "_token") {
											field.element.classList.add("has-error");
											var errorList = document.createElement("ul");
											errorList.classList.add("field-errors");
											
											[].forEach.call(field.data.errors, function(error) {
												var errorItem = document.createElement("li");
												errorItem.innerText = error;
												errorList.appendChild(errorItem);
											});
											
											field.element.parentNode.appendChild(errorList);
										} else {
											self.throwFormError(field.data.errors.join(", "));
										}
									}
								}
								
								var firstErrorElement = responseTarget.getElementsByClassName("has-error")[0];
								if (!self.isEmpty(firstErrorElement)) {
									self.scrollToElement(firstErrorElement);
								}
								
								setFormStep("default");
							} else {
								self.throwFormError(response);
							}
						} else {
							setLoader(true);
							formEvent.reset();
							setTimeout(function() {
								self.scrollToElement(self.form, function() {
									self.form.setAttribute("data-form-step", "complete");
									self.contactForm.step = "complete";
									setLoader(false);
								});
							}, 1000);
						}
					} else {
						self.throwFormError(data);
					}
				},
				error: function(xhr, data) {
					self.throwFormError(data);
				}
			});
		}
	}
	
	throwFormError(data) {
		var errorMessage = data.error;
		if (!this.isEmpty(errorMessage)) {
			swal({ title: "エラー", text: errorMessage, icon: "error" });
		} else {
			swal({ title: "エラー", text: data, icon: "error" });
		}
	}
};